<div class="wrapper">
  <form [formGroup]="createForm" class="drop-padding" (ngSubmit)="save()">
    <app-property-selector *ngIf="!prop_row" [control]="propertyControl"></app-property-selector>
    <h2 *ngIf="prop_row">{{ prop_row.property.description }}</h2>
    <app-value-selector [control]="valueControl" [property]="property"></app-value-selector>
    <button mat-flat-button color="primary" type="submit">Сохранить</button>
  </form>
</div>
